import React from 'react';
import { CodeEditorField } from '@dopomogai/ui';

interface LogPanelProps {
  logs: { timestamp: number; data: any }[];
}

export const LogPanel: React.FC<LogPanelProps> = ({ logs }) => {
  const logString = logs
    .map(log => `// ${new Date(log.timestamp).toISOString()}\n${JSON.stringify(log.data, null, 2)}`)
    .join('\n\n');

  return (
    <div className="h-full overflow-y-auto p-4">
      <CodeEditorField
        value={logString}
        language="json"
        readOnly
        theme="light"
        onChange={() => {}}
        // // The editor itself should fill the padded container
        showCopyButton
      />
    </div>
  );
};